export default __webpack_public_path__ + "static/treneri-jiri-pixa-68183c549e70b6fcd063fd661b79c8c7.jpg";